import React from 'react';
import { Box, Flex } from '../Rebass';
import Heading from '../Heading';
import Text from '../Text';
import { SxStyleProp } from '../Rebass/types';

interface NewsletterProps {
  headline: string;
  subtitle: string;
  renderForm: () => React.ReactNode;
  headlineSx?: SxStyleProp;
  sx?: SxStyleProp;
}

const Newsletter = ({
  headline,
  subtitle,
  renderForm,
  headlineSx,
  sx,
}: NewsletterProps) => {
  return (
    <Box data-testid="newsletter" sx={sx}>
      <Flex
        flexDirection={['column', 'row']}
        justifyContent="space-between"
        mb={[4, 10]}
      >
        <Box flex="1 0 50%">
          <Heading size="h2" sx={{ ...headlineSx }}>
            {headline}
          </Heading>
        </Box>
        <Box flex="1 1 auto">
          <Text size="body" color="textDark">
            {subtitle}
          </Text>
        </Box>
      </Flex>
      {renderForm && renderForm()}
    </Box>
  );
};

export default Newsletter;
